import { z } from 'zod';
import { Team } from './teamsheet';

export const TeamsheetEyeballSchema = z.object({
    id: z.number().int().nullable(),
    score: z.number(),
    search: z.array(z.object({
        id: z.number().int().optional(),
        discr: z.string().optional(),
        score: z.number().optional(),
        height: z.number().int().nullable().optional(),
        weight: z.number().int().nullable().optional(),
        club_id: z.number().int().nullable().optional(),
        team_id: z.number().int().nullable().optional(),
        birthday: z.string().nullable().optional(),
        full_name: z.string().optional(),
        last_name: z.string().optional(),
        position2: z.string().nullable().optional(),
        first_name: z.string().optional(),
        nationality: z.string().nullable().optional()
    }).partial()).nullable().optional(),
    mappingStage: z.number().int().nullable().optional()
}).transform((data) => ({
    ...data,
    mappingStage: data.mappingStage === null ? undefined : data.mappingStage
}));

export const TeamsheetProviderFormattedNameSchema = z.object({
    last_name: z.string().nullable(),
    first_name: z.string().nullable()
}).transform((data) => ({
    lastName: data.last_name,
    firstName: data.first_name
}));

export const TeamsheetProviderSchema = z.object({
    id: z.string().nullable().optional(),
    team: z.string().nullable().optional(),
    height: z.number().int().nullable().optional(),
    weight: z.number().int().nullable().optional(),
    birthday: z.string().nullable().optional(),
    starting: z.boolean().nullable().optional(),
    last_name: z.string().nullable().optional(),   
    first_name: z.string().nullable().optional(),
    heimspielId: z.number().int().nullable().optional(),
    nationality: z.string().nullable().optional(),
    shirtNumber: z.number().int().nullable().optional(),
    matchRosterId: z.string().nullable().optional(),
    formatted_name: TeamsheetProviderFormattedNameSchema.nullable().optional(),
    seasonRosterId: z.string().nullable().optional()
}).transform((data) => ({
    id: data.id,
    team: data.team as Team,
    height: data.height,
    weight: data.weight,
    birthday: data.birthday,
    starting: data.starting,
    lastName: data.last_name,
    firstName: data.first_name,
    heimspielId: data.heimspielId,
    nationality: data.nationality,
    shirtNumber: data.shirtNumber,
    matchRosterId: data.matchRosterId,
    formattedName: data.formatted_name,
    seasonRosterId: data.seasonRosterId
}));

export const TeamsheetPlayerDataSchema = z.object({
    eyeball: TeamsheetEyeballSchema,
    provider: TeamsheetProviderSchema.nullable().optional()
});

export const TeamsheetPlayerSchema = z.object({
    id: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    deleted: z.boolean(),
    task_id: z.string(),
    data: TeamsheetPlayerDataSchema,
    provider_player_id: z.string(),
    eyeball_player_id: z.number().int().nullable(),
    status: z.string()
}).transform((data) => ({
    id: data.id,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
    deleted: data.deleted,
    taskId: data.task_id,
    data: data.data,
    providerPlayerId: data.provider_player_id,
    eyeballPlayerId: data.eyeball_player_id,
    status: data.status
}));

export const ApiTaskSchema = z.array(z.object({
    video_id: z.string(),
    task_id: z.string().optional(),
    match_id: z.string().nullable().optional(),
    league: z.string().nullable().optional(),
    league_country: z.string().nullable(),
    home_team_id: z.number().int().nullable(),
    away_team_id: z.number().int().nullable(),
    home_team: z.string().nullable(),
    away_team: z.string().nullable(),
    video_status: z.string(),
    teamsheet_status: z.string(),
    eyeball_game_id: z.number().int().nullable(),
    game_date: z.string().nullable(),
    video_url: z.string().nullable(),
    updated_at: z.string(),
    category: z.string().nullable()
}).transform((data) => ({
    videoId: data.video_id,
    taskId: data.task_id,
    matchId: data.match_id,
    league: data.league,
    leagueCountry: data.league_country,
    homeTeamId: data.home_team_id,
    awayTeamId: data.away_team_id,
    homeTeam: data.home_team,
    awayTeam: data.away_team,
    videoStatus: data.video_status,
    teamsheetStatus: data.teamsheet_status,
    eyeballGameId: data.eyeball_game_id,
    gameDate: data.game_date,
    videoUrl: data.video_url,
    updatedAt: data.updated_at,
    category: data.category
})));

export const DieLigenTasksDataSchema = z.object({
    videos: ApiTaskSchema,
    total: z.number(),
    page: z.number(),
    pages: z.number(),
    limit: z.number()
}).transform((data) => ({
    videos: data.videos,
    total: data.total,
    page: data.page,
    pages: data.pages,
    limit: data.limit
}));